module.exports = __webpack_public_path__ + "static/media/goldwind.9817df36.png";